// @ts-nocheck
/* eslint react/no-array-index-key: 0 */
import _ from 'lodash';
import set from 'lodash/fp/set';
import React, { Component } from 'react';
import { inject, observer } from "../../../../stores/mobx-compat";
import { SortableList, SortableItem, ensureDndId } from '../sortable';
import axios from 'axios';
import { withRouter } from '../../../../router-compat';

import Card, { CardHead } from '../../../ui/Card';
import Button from '../../../ui/Button';
import IconButton from '../../../ui/IconButton';
import Input from '../../../ui/Input';
import Textarea from '../../../ui/Textarea';
import Select from '../../../ui/Select';
import FormGroup from '../../../ui/FormGroup';
import DropdownMenu, { MenuItem, MenuSection } from '../../../ui/DropdownMenu';
import Tooltip from '../../../ui/Tooltip';
import PageHeader from '../../../ui/PageHeader';
import {
  ChevronLeftIcon, PlusIcon, TrashIcon, MailIcon, InfoIcon,
} from '../../../ui/icons';
import { arrayMove } from '../../../../helper';
import { API_URL } from '../../../../configs';

const LogicRow = ({
  logic, fields, index, color, onRemove, onChange,
}) => {
  const text = fields.find((f) => f.key === 'text');
  const others = fields.filter((f) => f.key !== 'text');
  return (
    <Card padded className="mb-3" style={{ borderTop: `2px solid ${color}`, cursor: 'grab' }}>
      <div className="flex items-center justify-between mb-3">
        <h4 className="m-0 text-[14px] font-semibold">
          {index + 1}. {logic.creative}
        </h4>
        <IconButton variant="ghost" icon={TrashIcon} ariaLabel="Remove" onClick={() => onRemove(index)} />
      </div>
      <div className="grid gap-3 mb-3" style={{ gridTemplateColumns: 'repeat(3, minmax(0, 1fr))' }}>
        {others.map((f) => (
          <FormGroup
            key={f.key}
            label={(
              <span className="inline-flex items-center gap-1.5">
                {f.labelprop}
                {f.datatooltip && (
                  <Tooltip content={f.datatooltip}>
                    <span className="text-mov-ink-mute"><InfoIcon size={12} /></span>
                  </Tooltip>
                )}
              </span>
            )}
          >
            <Input
              type={f.type}
              value={f.value}
              readOnly={f.readOnly}
              onChange={(e) => onChange(null, { name: f.name, value: e.target.value })}
            />
          </FormGroup>
        ))}
      </div>
      {text && (
        <FormGroup label="Body (optional)">
          <Textarea
            value={text.value}
            onChange={(e) => onChange(null, { name: text.name, value: e.target.value })}
          />
        </FormGroup>
      )}
    </Card>
  );
};
class EditForms extends Component {
  get formNode() {
    const node = _.get(this.props, ['store', 'forms', 'forms', this.url.hostname, 'paths', this.url.pathname], null);
    const logic = _.get(node, 'emailLogic.logic', []).map(({
      creative, minuteDifference, subject, text, hourDifference = minuteDifference / 60,
    }) => ({ creative, hourDifference, subject, text }));
    _.set(node, 'emailLogic.logic', logic);
    return node;
  }

  constructor(props) {
    super(props);
    const { selection, location } = props;
    const selectionURL = location && location.state ? location.state.data : null;
    const sel = selection || selectionURL;
    if (sel) {
      this.url = new URL(sel.startsWith('https://') ? sel : `https://${sel}`);
    }
    this.state = {
      settings: { domain: '', sender: '' },
      logic: [],
      search: '',
      selection: selectionURL,
      relevantTemplates: [],
      userEmail: '',
      emailDomains: [],
      saveSettingsClicked: false,
    };
  }

  componentDidMount() {
    this.getFormNode();
    this.getEmailDomains();
    if (this.state.settings.domain) this.getRelevantTemplates();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.settings.domain && prevState.settings.domain !== this.state.settings.domain) {
      this.setState({ search: '' });
    }
    if (this.state.userEmail && prevState.userEmail !== this.state.userEmail) {
      this.getRelevantTemplates();
    }
  }

  getFormNode = () => {
    const node = _.get(this.props, ['store', 'forms', 'forms', this.url.hostname, 'paths', this.url.pathname], null);
    const logic = _.get(node, 'emailLogic.logic', []).map(({
      creative, minuteDifference, subject, text, hourDifference = minuteDifference / 60,
    }) => ({ creative, hourDifference, subject, text }));
    _.set(node, 'emailLogic.logic', logic);
    const { emailLogic = {} } = node;
    this.setState({
      settings: {
        domain: emailLogic.emailDomain || node.emailDomain || '',
        sender: emailLogic.emailSender || node.emailSender || '',
      },
      logic: (emailLogic.logic || []).map(ensureDndId),
      userEmail: emailLogic.emailDomain || node.emailDomain,
    });
  }

  getEmailDomains = async () => {
    try {
      const { data } = await axios.get(`${API_URL}/api/em/email-domains`);
      this.setState({
        emailDomains: _.reduce(data.emailDomains, (acc, settings, domain) => {
          if (settings.status === 'active') acc.push(domain);
          return acc;
        }, []),
      });
    } catch (e) {
      this.props.store.failure('Error getting email domains');
    }
  }

  getRelevantTemplates = async () => {
    try {
      const { data } = await axios.get(`${API_URL}/api/em/email-templates?active=false&limit=100&emailDomain=${this.state.userEmail}`);
      if (data.success) this.setState({ relevantTemplates: data.templates });
    } catch (e) {
      this.props.store.failure('Failed to get templates');
    }
  }

  onInputChange = (_e, { name, value }) => {
    this.setState((prev) => set(name, value, prev));
  }

  onSortEnd = ({ oldIndex, newIndex }) => {
    this.setState(({ logic }) => ({ logic: arrayMove(logic, oldIndex, newIndex) }));
  };

  get emailColors() {
    const palette = ['#7ac142', '#43bccd', '#7913c6', '#f86624', '#c9912a', '#ea3546'];
    return this.state.relevantTemplates.reduce((acc, t, i) => {
      acc[t.name] = palette[i % palette.length];
      return acc;
    }, {});
  }

  get logicFields() {
    return this.state.logic.map((config, i) => _.map(config, (val, key) => {
      const f = { key, name: `logic.[${i}].${key}`, labelprop: _.startCase(key), value: val };
      if (key === 'creative') { f.labelprop = 'Template name'; f.readOnly = true; f.datatooltip = 'Name of the selected email.'; }
      else if (key === 'hourDifference') { f.labelprop = 'Hour delay'; f.type = 'number'; f.datatooltip = 'Hours before this email is sent.'; }
      else if (key === 'subject') { f.datatooltip = 'Subject line.'; }
      else if (key === 'text') { f.datatooltip = 'Plain-text fallback body.'; }
      return f;
    }));
  }

  addEmail = (templateName) => {
    this.setState(({ logic }) => ({
      logic: [...logic, ensureDndId({ creative: templateName, hourDifference: 24, subject: '', text: '' })],
    }));
  }

  removeEmail = (index) => {
    this.setState(({ logic }) => ({
      logic: [...logic.slice(0, index), ...logic.slice(index + 1)],
    }));
  }

  saveSettings = async () => {
    const { domain, sender } = this.state.settings;
    const { userEmail, logic } = this.state;
    if (domain !== userEmail && domain && sender) {
      await this.props.store.emailManagement.saveEmailSettings({ url: this.url, domain, sender });
      if (logic.length) {
        await this.props.store.emailManagement.saveEmailLogic({
          url: this.url, logic: [], emailDomain: domain, emailSender: sender,
        });
      }
      this.setState({ logic: [], saveSettingsClicked: true });
    } else {
      await this.props.store.emailManagement.saveEmailSettings({ url: this.url, domain, sender, logic });
    }
    const { emailLogic } = this.formNode;
    const { emailDomain, emailSender } = emailLogic;
    this.setState({
      settings: {
        domain: domain && sender ? emailDomain : domain,
        sender: domain && sender ? emailSender : sender,
      },
      userEmail: emailDomain,
    });
  }

  saveLogic = async () => {
    const newLogic = this.state.logic.map((config) => _.pick(
      { ...config, minuteDifference: Number(config.hourDifference) * 60 },
      ['creative', 'minuteDifference', 'subject', 'text'],
    ));
    await this.props.store.emailManagement.saveRecoverEmails({
      url: this.url,
      logic: newLogic,
      emailDomain: this.state.settings.domain,
      emailSender: this.state.settings.sender,
    });
  }

  render() {
    const { settings, search, relevantTemplates, saveSettingsClicked } = this.state;
    const filtered = relevantTemplates.filter((t) => t.name.toLowerCase().includes(search.toLowerCase()));
    const { saveEmailSettings: settingsLoading, saveEmailLogic: logicLoading } = this.props.store.emailManagement.loading;

    return (
      <>
        <PageHeader
          eyebrow="Forms · edit"
          title={<>Recover <em>email</em> logic.</>}
          sub={this.props.selection || this.state.selection}
        />

        <div className="flex items-center gap-3 mb-4">
          <IconButton icon={ChevronLeftIcon} ariaLabel="Back" onClick={() => this.props.history.goBack()} />
          <span className="text-[13px] text-mov-ink-soft">Back to forms</span>
        </div>

        <Card padded className="mb-5">
          <CardHead title="Email settings" />
          <div className="grid gap-4" style={{ gridTemplateColumns: 'repeat(2, minmax(0, 1fr))' }}>
            <FormGroup label="Email domain">
              <Select
                value={settings.domain}
                onChange={(e) => this.onInputChange(null, { name: 'settings.domain', value: e.target.value })}
              >
                <option value="">Select a domain…</option>
                {this.state.emailDomains.map((d) => <option key={d} value={d}>{d}</option>)}
              </Select>
            </FormGroup>
            <FormGroup label="Sender" help="Format: 'Noreply noreply@'">
              <Input
                value={settings.sender}
                placeholder="Noreply noreply@"
                onChange={(e) => this.onInputChange(null, { name: 'settings.sender', value: e.target.value })}
              />
            </FormGroup>
          </div>
          <div className="mt-3 flex justify-end">
            <Button variant="primary" loading={settingsLoading} onClick={this.saveSettings}>
              Save settings
            </Button>
          </div>
        </Card>

        <Card padded className="mb-5">
          <CardHead
            title="Recover emails"
            sub="Drag to reorder. Hours are counted from form abandonment."
          />
          {this.state.logic.length === 0 ? (
            <p className="m-0 text-[13px] text-mov-ink-mute">No emails configured.</p>
          ) : (
            <SortableList
              ids={this.state.logic.map((l) => l._dndId)}
              onSortEnd={this.onSortEnd}
            >
              {this.state.logic.map((logic, i) => (
                <SortableItem key={logic._dndId} id={logic._dndId}>
                  <LogicRow
                    index={i}
                    logic={logic}
                    fields={this.logicFields[i]}
                    color={this.emailColors[logic.creative]}
                    onChange={this.onInputChange}
                    onRemove={this.removeEmail}
                  />
                </SortableItem>
              ))}
            </SortableList>
          )}
          <div className="mt-3 flex justify-end gap-2">
            <Button
              variant="primary"
              icon={MailIcon}
              loading={!saveSettingsClicked && logicLoading}
              onClick={this.saveLogic}
            >
              Save emails
            </Button>
            <DropdownMenu
              align="right"
              width={280}
              trigger={<Button icon={PlusIcon}>Add email</Button>}
            >
              <div className="px-2 pb-2 pt-1">
                <Input
                  placeholder="Search templates…"
                  value={search}
                  onChange={(e) => this.setState({ search: e.target.value })}
                />
              </div>
              <MenuSection>{this.state.userEmail || 'Templates'}</MenuSection>
              {filtered.length === 0 && (
                <div className="px-3 py-3 text-[12.5px] text-mov-ink-mute">No matches</div>
              )}
              {filtered.map((t) => (
                <MenuItem
                  key={t.name}
                  onSelect={() => this.addEmail(t.name)}
                  icon={() => (
                    <span
                      aria-hidden="true"
                      style={{ width: 10, height: 10, borderRadius: '50%', background: this.emailColors[t.name] }}
                    />
                  )}
                >
                  {t.name}
                </MenuItem>
              ))}
            </DropdownMenu>
          </div>
        </Card>
      </>
    );
  }
}

export default withRouter(inject('store')(observer(EditForms)));
